// config.js
import { stack, stackOffsetDiverging } from 'd3-shape';
import { min, max } from 'd3-array';
import { linearAxis, bandAxis } from '../../../factory/axes';
import { ordinalScale } from '../../../factory/scales';

export default function (props) {
  const { initialWidth, data } = props;

  // Extract keys from the first row (ignoring the "label" column)
  const keys = Object.keys(data[0]).slice(1);

  // Create stacked series
  const series = stack()
    .offset(stackOffsetDiverging) // or stackOffsetNone if all positive
    .keys(keys)(data);

  const maxValue = max(series, serie => max(serie, d => d[1]));
  const minValue = min(series, serie => min(serie, d => d[0]));

  const margins = {
    top: 0,
    right: 20,
    bottom: 20,
    left: 50,
  };

  const barHeight = 40;
  const padding = 0.2;

  // We have only 1 row, so height can be barHeight + some padding
  const width = initialWidth - margins.right - margins.left;
  const height = data.length * (barHeight + (barHeight * padding));

  // X-axis from negative to positive range if needed
  const xAxisConfig = {
    orientation: 'bottom',
    range: [0, width],
    domain: [Math.min(0, minValue), maxValue],
    nice: false,
  };

  const yAxisConfig = {
    orientation: 'left',
    range: [0, height],
    domain: data.map(d => d.label),
    padding,
  };

  const { axis: xAxis, scale: x } = linearAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = bandAxis(yAxisConfig);

  const colorScale = ordinalScale({
    domain: keys,
    range: ['#7c4ea5', '#4d3370', '#9c80c1', '#999999'],
  });

  return {
    colorScale,
    data: series,
    height,
    initialWidth,
    initialHeight: height + margins.top + margins.bottom,
    margins,
    width,
    x,
    xAxis,
    y,
    yAxis,
  };
}
